import { render, staticRenderFns } from "./starBackground.vue?vue&type=template&id=da76ac94&scoped=true&"
import script from "./starBackground.vue?vue&type=script&lang=js&"
export * from "./starBackground.vue?vue&type=script&lang=js&"
import style0 from "./starBackground.vue?vue&type=style&index=0&id=da76ac94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da76ac94",
  null
  
)

export default component.exports